import { TableCell, TableRow } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/styles';
import formatters from '../../../../Core/Grid/inputFormatter';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import { useContext } from 'react';

const useStyles = makeStyles({
    mainClass: {
        background: (props) => props.footerBgColor,
        color: (props) => props.footerTextColor
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        // border: 'none'
        border: '1px solid rgba(0, 0, 0, 0.09)'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const MADashYtdFooterRow = ({ config, categoryCount, totals }) => {
    const portalSettings = AppStorage.getPortalSetting();
    const classes = useStyles(config);
    const { ThousandSeparatorWithoutZero } = useContext(BranchFranchiseCompareContext);

    let actualAlign = portalSettings.portalSettingMADashboardActualAlign;
    let budgetAlign = portalSettings.portalSettingMADashboardBudgetAlign;
    let varianceAlign = portalSettings.portalSettingMADashboardVarianceAlign;
    let kpiAlign = portalSettings.portalSettingMADashboardKPIsAlign;
    let actualPYAlign = portalSettings.portalSettingMADashboardActualPYAlign;
    let varLYAlign = portalSettings.portalSettingMADashboardVarPYAlign;

    const getCellValue = (value, hasAverage) => {
        return hasAverage
            ? categoryCount > 0
                ? ThousandSeparatorWithoutZero(value / categoryCount, config.dp)
                : '0'
            : ThousandSeparatorWithoutZero(value, config.dp);
    };

    const getKPIValue = (value, hasAverage) => {
        return hasAverage
            ? // ? categoryCount > 0
              parseFloat(ThousandSeparatorWithoutZero(value / categoryCount, config.dp)) + '%'
            : // : '0%'
              parseFloat(ThousandSeparatorWithoutZero(value, config.dp)) + '%';
    };

    const { actual, budget, actualLY, varLY, variance, ytdActual, ytdActualLY, ytdBudget, ytdVarLY, ytdVariance, totalKpi, totalYTDKpi } = totals;

    return (
        <TableRow>
            <StyledTableCell className={classes.mainClass} align="left">
                <b>{config.footerTitle}</b>
            </StyledTableCell>

            {/* MTD */}
            <StyledTableCell className={classes.mainClass} align={actualAlign}>
                <b>{getCellValue(actual, config.actualHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={budgetAlign}>
                <b>{getCellValue(budget, config.budgetHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={varianceAlign}>
                <b>{getCellValue(variance || 0, config.varianceHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={kpiAlign}>
                <b>{getCellValue(totalKpi || 0, config.kpIsHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={actualPYAlign}>
                <b>{getCellValue(actualLY, config.actualPYHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={varLYAlign}>
                <b>{getCellValue(varLY, config.varLYHasAverage)}</b>
            </StyledTableCell>

            {/* YTD */}
            <StyledTableCell className={classes.mainClass} style={{ borderLeft: '2px solid grey' }} align={actualAlign}>
                <b>{getCellValue(ytdActual, config.actualHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={budgetAlign}>
                <b>{getCellValue(ytdBudget, config.budgetHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={varianceAlign}>
                <b>{getCellValue(ytdVariance || 0, config.varianceHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={kpiAlign}>
                <b>{getCellValue(totalYTDKpi, config.kpIsHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={actualPYAlign}>
                <b>{getCellValue(ytdActualLY, config.actualPYHasAverage)}</b>
            </StyledTableCell>
            <StyledTableCell className={classes.mainClass} align={varLYAlign}>
                <b>{getCellValue(ytdVarLY, config.varLYHasAverage)}</b>
            </StyledTableCell>
        </TableRow>
    );
};

export default MADashYtdFooterRow;
